import { render } from "./Principal.vue?vue&type=template&id=1e86bfa0&scoped=true"
const script = {}

import "./Principal.vue?vue&type=style&index=0&id=1e86bfa0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e86bfa0"]])

export default __exports__